import { clean } from '../clean-stores/index.js';
var listenerQueue = [];
export var notifyId = 0;
export var atom = function atom(initialValue, level) {
  var currentListeners;
  var nextListeners = [];
  var store = {
    lc: 0,
    l: level || 0,
    value: initialValue,
    set: function set(data) {
      store.value = data;
      store.notify();
    },
    get: function get() {
      if (!store.lc) {
        store.listen(function () {})();
      }

      return store.value;
    },
    notify: function notify(changedKey) {
      currentListeners = nextListeners;
      var runListenerQueue = !listenerQueue.length;

      for (var i = 0; i < currentListeners.length; i += 2) {
        listenerQueue.push(currentListeners[i], store.value, changedKey, currentListeners[i + 1]);
      }

      if (runListenerQueue) {
        notifyId++;

        for (var _i = 0; _i < listenerQueue.length; _i += 4) {
          var skip = false;

          for (var j = _i + 7; j < listenerQueue.length; j += 4) {
            if (listenerQueue[j] < listenerQueue[_i + 3]) {
              skip = true;
              break;
            }
          }

          if (skip) {
            listenerQueue.push(listenerQueue[_i], listenerQueue[_i + 1], listenerQueue[_i + 2], listenerQueue[_i + 3]);
          } else {
            listenerQueue[_i](listenerQueue[_i + 1], listenerQueue[_i + 2]);
          }
        }

        listenerQueue.length = 0;
      }
    },
    listen: function listen(listener, listenerLevel) {
      if (nextListeners === currentListeners) {
        nextListeners = nextListeners.slice();
      }

      store.lc = nextListeners.push(listener, listenerLevel || store.l) / 2;
      return function () {
        if (nextListeners === currentListeners) {
          nextListeners = nextListeners.slice();
        }

        var index = nextListeners.indexOf(listener);

        if (~index) {
          nextListeners.splice(index, 2);
          store.lc--;
          if (!store.lc) store.off();
        }
      };
    },
    subscribe: function subscribe(cb, listenerLevel) {
      var unbind = store.listen(cb, listenerLevel);
      cb(store.value);
      return unbind;
    },
    off: function off() {}
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */

  };

  if (process.env.NODE_ENV !== 'production') {
    store[clean] = function () {
      nextListeners = [];
      store.lc = 0;
      store.off();
    };
  }

  return store;
};